module.exports = __webpack_public_path__ + "img/under-maintenance.49b56858.png";